// extracted by mini-css-extract-plugin
export default {"button":"scrollToTopButton_button__Qo3M0","buttonVisible":"scrollToTopButton_buttonVisible__x4IuM","icon":"scrollToTopButton_icon__-S2JR"};